var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mtd-cascader',{staticClass:"cascader",attrs:{"data":_vm.sgCategoryList,"placeholder":"请选择品类","filterable":"","props":{
        label:'label',
        value:'id',
        children:'children'
    },"disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }